<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Pembayaran</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-form-group label="Cabang">
                        <div class="mr-2">
                            <multiselect
                                name="cabang"
                                v-model="input.cabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang --"
                            />
                        </div>
                    </b-form-group>
                    <b-form-group label="Tipe Pinjaman">
                        <b-form-select class="mr-2" v-model="input.tipe" name="tipe" :options="tipeOption" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih Tipe Pinjaman --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Metode Pembayaran">
                        <b-form-select class="mr-2" v-model="input.metodePembayaran" name="metodePembayaran" :options="optionPembayaran" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih metode --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group class="small-input-date">
                        <b-form-radio v-model="dateType" value="harian">
                            <span>Harian</span>
                            <div class="d-flex search-input-wrapper">
                                <b-form-input v-model="input.tanggal" name="tanggal" type="date" :min="minDate" :max="maxDate"></b-form-input>
                            </div>
                        </b-form-radio>
                    </b-form-group>
                    <b-form-group v-if="this.fullAccess != 1" class="small-input-date">
                        <b-form-radio v-model="dateType" value="bulanan">
                            <span>Bulanan</span>
                            <b-form-select v-model="input.bulan" id="inputBulan" name="inputBulan" :options="optionBulan" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-radio>
                    </b-form-group>
                    <b-form-group v-else class="small-select-date">
                        <b-form-radio v-model="dateType" value="bulanan">
                            <span>Bulanan</span>
                            <div class="d-flex">
                                <b-form-select class="mr-2 mb-2" v-model="input.bulan" id="inputBulan" name="inputBulan" :options="bulan" value-field="id" text-field="name">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-form-select v-model="input.tahun" id="inputTahun" name="inputTahun" :options="optionTahun">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                        </b-form-radio>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="submitLaporan" variant="pgiBtn">Cetak</b-button>
                </div>
            </b-form>
            
            <div v-if="urlLaporan != null">
                <p class="smallText text-muted">Bila laporan tidak muncul setelah lebih dari 30 detik / hanya menampilkan warna abu-abu dengan error, klik 
                    <a :href="urlLaporan" target="_blank">link</a> ini, atau hubungi HO.
                </p>
                <iframe width="100%" height="1000" :src= urlLaporan frameborder="0" allowfullscreen></iframe>
            </div>
        </b-card>
        <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak Laporan Pembayaran" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak laporan pembayaran ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'laporan-pembayaran',
    data(){
        return{
            isSubmitting: false,
            cabang: null,
            fullAccess: null,
            input: {
                cabang: null,
                tipe: null,
                tanggal: null,
                bulan: null,
                tahun: null,
                metodePembayaran: null
            },
            cabangOption: [],
            optionBulan: [],
            optionTahun: [],
            tipeOption: [
                { id: "GE", name: "Gadai Elektronik" },
                { id: "GB", name: "Gadai BPKB" },
                { id: "GG", name: "Gadai Emas" }
            ],
            bulan: [
                { id: "1", name: "Januari" },
                { id: "2", name: "Februari" },
                { id: "3", name: "Maret" },
                { id: "4", name: "April" },
                { id: "5", name: "Mei" },
                { id: "6", name: "Juni" },
                { id: "7", name: "Juli" },
                { id: "8", name: "Agustus" },
                { id: "9", name: "September" },
                { id: "10", name: "Oktober" },
                { id: "11", name: "November" },
                { id: "12", name: "Desember" }
            ],
            optionPembayaran: [
                { id: true, name: "Tunai" },
                { id: false, name: "Non-Tunai" }
            ],
            dateType: "harian",
            urlLaporan: null,
            minDate: null,
            maxDate: null
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.cabangOption = this.$helper.getAllCabang()

            this.$axios.get('laporan/durasi-laporan').then(response => {
                this.fullAccess = response.data.id
                
                let date = new Date().toISOString().slice(0,10)
                this.input.tanggal = date
                
                // Harian

                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1; //January is 0!
                var yyyy = today.getFullYear();
                if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                today = yyyy+'-'+mm+'-'+dd;
                this.maxDate = today

                if (this.fullAccess != 1){
                    var threeDaysAgo = new Date()
                    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
                    var dd = threeDaysAgo.getDate()
                    var mm = threeDaysAgo.getMonth()+1
                    var yyyy = threeDaysAgo.getFullYear()
                    if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                    threeDaysAgo = yyyy+'-'+mm+'-'+dd;
                    this.minDate = threeDaysAgo
                }


                // Bulanan

                var months = ["Januari", "Februari", "Maret", "April", 
                                "Mei", "Juni", "Juli", "Agustus", 
                                "September", "Oktober", "November", "Desember"]
                
                if (this.fullAccess != 1){
                    var d = new Date()
                    var thisMonth = d.getMonth()
                    var thisYear = d.getFullYear()

                    var lastMonth = d.getMonth() - 1
                    if(lastMonth < 0){
                    lastMonth += 12
                        d.setYear(d.getYear() - 1)
                        var lastYear = d.getFullYear()
                    } else {
                        var lastYear = thisYear
                    }

                    this.optionBulan = [
                        { id: thisMonth+"-"+thisYear, name:months[thisMonth]+" "+thisYear },
                        { id: lastMonth+"-"+lastYear, name:months[lastMonth]+" "+lastYear }
                    ]
                } else {
					var thisYear = new Date().getFullYear()
                    for(var i = 2019; i <= thisYear; i++) {
                        this.optionTahun.push(i)
                    }
                }
            })
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            this.isSubmitting = true

            if (this.dateType == 'harian'){
                this.$axios.get("laporan/pembayaran/?cabangId="+this.input.cabang.id+"&startDate="+this.input.tanggal
                                +"&endDate="+this.input.tanggal+"&tipePinjaman="+this.input.tipe+"&tunai="+this.input.metodePembayaran).then(response => {
                    this.urlLaporan = this.$baseFilePath+response.data

                    this.$helper.setFlash(`Laporan pembayaran berhasil dibuat!`)
                    this.$bvModal.hide("modal-confirm-cetak")
                    
                    let msg = this.$helper.getFlash()
                    this.$helper.toastSucc(this, msg)
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            } else {
                this.$axios.get("laporan/pembayaran/?cabangId="+this.input.cabang.id+"&month="+this.input.bulan
                                +"&year="+this.input.tahun+"&tipePinjaman="+this.input.tipe+"&tunai="+this.input.metodePembayaran).then(response => {
                    this.urlLaporan = this.$baseFilePath+response.data

                    this.$helper.setFlash(`Laporan pembayaran berhasil dibuat!`)
                    this.$bvModal.hide("modal-confirm-cetak")
                    
                    let msg = this.$helper.getFlash()
                    this.$helper.toastSucc(this, msg)
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }
        },

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (this.input.cabang == null || this.input.tipe == null || this.input.metodePembayaran == null || 
                    this.dateType == 'harian' && !this.$helper.isNotNullAndNotEmpty(this.input.tanggal) || 
                    this.dateType == 'bulanan' && this.input.bulan == null ||
                    this.dateType == 'bulanan' && this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon lengkapi data untuk cetak laporan!")
            } else {
                this.$bvModal.show("modal-confirm-cetak")
            }            
        }
    },

    created(){
        this.init()
    }
}
</script>